import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LangLink } from '../common/LangLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShieldAlt,
  faChevronDown,
  faTachometerAlt,
  faChartLine,
  faTags,
  faListAlt,
  faUsers,
  faEyeSlash,
  faChartPie,
  faFire,
  faHeart,
  faGavel,
  faIdCard,
  faMoneyBillWave,
  faHandshake, // --- 1. Importar el nuevo ícono para Referidos ---
} from '@fortawesome/free-solid-svg-icons';

const AdminMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-semibold text-secondary-dark dark:text-secondary-light bg-secondary/10 hover:bg-secondary/20 transition"
      >
        <FontAwesomeIcon icon={faShieldAlt} />
        <span>Admin</span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-white dark:bg-neutral-800 shadow-xl rounded-xl z-50 border border-neutral-200 dark:border-neutral-700">
          <div className="p-2">
            <LangLink
              to="/admin/dashboard"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon
                icon={faTachometerAlt}
                className="w-5 text-center"
              />
              <span>Dashboard Principal</span>
            </LangLink>

            <div className="my-1 h-px bg-neutral-200 dark:bg-neutral-700"></div>

            <p className="px-3 pt-2 pb-1 text-xs font-semibold text-neutral-400 uppercase">
              Reportes
            </p>
            <LangLink
              to="/admin/commission-report"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faChartLine} className="w-5 text-center" />
              <span>Comisiones</span>
            </LangLink>
            <LangLink
              to="/admin/creator-report"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faChartPie} className="w-5 text-center" />
              <span>Creadores</span>
            </LangLink>
            <LangLink
              to="/admin/trending-content"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faFire} className="w-5 text-center" />
              <span>Contenido Popular</span>
            </LangLink>
            <LangLink
              to="/admin/top-supporters-report"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faHeart} className="w-5 text-center" />
              <span>Top Apoyos</span>
            </LangLink>

            <div className="my-1 h-px bg-neutral-200 dark:bg-neutral-700"></div>
            <p className="px-3 pt-2 pb-1 text-xs font-semibold text-neutral-400 uppercase">
              Gestión
            </p>
            <LangLink
              to="/admin/users"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faUsers} className="w-5 text-center" />
              <span>Usuarios</span>
            </LangLink>

            {/* --- 2. INICIO DE LA MODIFICACIÓN --- */}
            {/* Añadido el enlace de Pagos que faltaba */}
            <LangLink
              to="/admin/payouts"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon
                icon={faMoneyBillWave}
                className="w-5 text-center"
              />
              <span>Gestión de Pagos</span>
            </LangLink>
            {/* Añadido el nuevo enlace de Referidos */}
            <LangLink
              to="/admin/referral-report"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faHandshake} className="w-5 text-center" />
              <span>Gestión de Referidos</span>
            </LangLink>
            {/* --- FIN DE LA MODIFICACIÓN --- */}

            <LangLink
              to="/admin/verifications"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faIdCard} className="w-5 text-center" />
              <span>Verificaciones (KYC)</span>
            </LangLink>
            <LangLink
              to="/admin/content-management"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faEyeSlash} className="w-5 text-center" />
              <span>Contenido Reportado</span>
            </LangLink>
            <LangLink
              to="/admin/dmca-claims"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faGavel} className="w-5 text-center" />
              <span>Gestión DMCA</span>
            </LangLink>

            <div className="my-1 h-px bg-neutral-200 dark:bg-neutral-700"></div>
            <p className="px-3 pt-2 pb-1 text-xs font-semibold text-neutral-400 uppercase">
              Configuración
            </p>
            <LangLink
              to="/admin/categories"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faListAlt} className="w-5 text-center" />
              <span>Categorías</span>
            </LangLink>
            <LangLink
              to="/admin/attributes"
              onClick={() => setIsOpen(false)}
              className="px-3 py-2 flex items-center gap-3 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 transition"
            >
              <FontAwesomeIcon icon={faTags} className="w-5 text-center" />
              <span>Atributos</span>
            </LangLink>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminMenu;
